import React from "react";
import { ListItem, ListItemIcon, ListItemText, Link } from "@material-ui/core";
import { ILoginForm } from "../types";
import { NavLink } from "react-router-dom";
import ContactMailIcon from "@material-ui/icons/ContactMail";
import websitecontext from "../context/websitecontext";

interface Props {
  caseForm: ILoginForm;
}
const CaseFormItem: React.FC<Props> = ({ caseForm }) => {
  const context = React.useContext<any>(websitecontext);
  const { isPreview, previewKey, lang } = context;

  return (
    <>
      <ListItemIcon>
        <ContactMailIcon />
      </ListItemIcon>
      <ListItemText>
        <Link
          component={NavLink}
          to={isPreview ? `/form/${caseForm.WebFormId}?previewKey=${previewKey}&lang=${lang}`
            : `/form/${caseForm.WebFormId}`}
        >
          {caseForm.WebsiteLinkTitle || caseForm.WebsiteFormTitle}
        </Link>
      </ListItemText>
    </>
  );
};

export default React.memo(CaseFormItem);
